import { isNotNullOrEmpty } from "../string";
export const ERR_FAILED = "failed";
export const ERR_INVALID_STATE = "invalid state";
export const ERR_INVALID_ARGUMENT = "invalid argument";
export const ERR_NOT_IMPLEMENTED = "not implemented";
export const ERR_NOT_AVAILABLE = "not available";
export function newError(pCategory, pMessage) {
    if (isNotNullOrEmpty(pMessage))
        return (new Error(pCategory + ":" + pMessage));
    else
        return (new Error(pCategory));
}
export function rejectError(pCategory, pMessage) {
    return (Promise.reject(newError(pCategory, pMessage)));
}
